export const OFFER_CARDS = [
  {
    icon: "fas fa-code",
    title: "Single Page",
    description: "Creating small web pages (single page) of different designs",
  },
  {
    icon: "fab fa-react",
    title: "Web site",
    description: "Creating large web pages (multi-page) of different designs.",
  },
  // {
  //   icon: "fas fa-database",
  //   title: "Database",
  //   description:
  //     "Creating Pl SQL, MySQL, PostgreSQL databases. Create, Update, and delete on tables.",
  // },
  // {
  //   icon: "fab fa-java",
  //   title: "Java Web Backend",
  //   description: "Prepare backend for different web pages",
  // },
  {
    icon: "far fa-lightbulb",
    title: "Different Animations",
    description: "Preparation of various animations",
  },
];
